import { isNotNil_default } from "./isNotNil-CyoCgKa0.mjs";
import { nullToUndefined_default } from "./nullToUndefined-DPLuoDzT.mjs";

//#region src/prop.ts
/**
* Gets a key from an object if it exists.
*
* * Returns a value or undefined.
* * Never returns null.
* * Works with null or undefined inputs.
* * TypeSafe and correctly infers output type.
* * Does not require type parameters, but you can use them.
* * Can be used to get an item from an Array by index
*
* @private
*/
function prop(key, obj) {
	return arguments.length === 2 && isNotNil_default(key) && isNotNil_default(obj) ? nullToUndefined_default(obj?.[key]) : arguments.length === 1 ? (_obj) => _obj ? nullToUndefined_default(_obj[key]) : void 0 : void 0;
}

//#endregion
export { prop };
//# sourceMappingURL=prop-EvtVJxu8.mjs.map